import { useEffect, useMemo, useState } from "react";
import { AppState } from "react-native";

export const useAppActivityState = () => {
  const currentState = AppState.currentState;
  const [appState, setAppState] = useState(currentState);

  useEffect(() => {
    const appEventListener = AppState.addEventListener("change", setAppState);

    return () => {
      appEventListener?.remove();
    };
  }, []);

  return appState;
};

export const useIsAppActive = () => {
  const appState = useAppActivityState();
  return useMemo(() => appState === "active", [appState]);
};
